@if(visible){
<div class="loading-overlay" animate.enter="enter-background-animation" animate.leave="leave-animation">
    <div class="loading-backdrop"></div>
    <div class="loading-content" animate.enter="enter-animation" animate.leave="leave-animation">
        <svg class="plumap" viewBox="0 0 230 222" style="overflow: visible;">
            <path class="plumap-body" d="M105,52 C150,52 175,88 175,132 C175,182 148,210 105,210 C62,210 35,178 35,130 C35,86 60,52 105,52 Z"></path>
            <g class="plumap-face">
                <circle cx="82" cy="128" r="22"></circle>
                <circle cx="130" cy="128" r="22"></circle>
            </g>
            <ellipse class="plumap-eye" cx="82" cy="129" rx="5" ry="6.6"></ellipse>
            <ellipse class="plumap-eye" cx="130" cy="129" rx="5" ry="6.6"></ellipse>
            <path class="plumap-mouth" d="M85,158 Q105,181 125,158"></path>
            <g class="plumap-stem">
                <path class="plumap-stem-line" d="M103,53 C99,34 106,22 118,20"></path>
                <g class="plumap-leaf-fold">
                    <path class="plumap-leaf" d="M117,21 C130,6 152,6 163,17 C150,27 128,29 117,21 Z"></path>
                </g>
            </g>
        </svg>
        <div class="message">
            <span class="phrase" [class.phrase-hidden]="!phraseVisible()">{{ phrase() }}</span>
        </div>
    </div>
</div>
}